/**
 * TradingView's free widgets, as the frames their embed scripts would build.
 *
 * Each `embed-widget-<name>.js` script does nothing but write one iframe —
 * `tradingview-widget.com/embed-widget/<name>/` with its settings JSON in the
 * hash, plus the size and the `utm_*` / `page-uri` fields TradingView reads the
 * host page from. Framed directly here instead: the script runs on our page,
 * and when its container goes before it has loaded (React's dev-mode double
 * mount, switching tab mid-load) it throws, cross-origin, as a bare
 * "Script error." that CRA's overlay takes over the screen with.
 *
 * `page-uri` is the Trademate route rather than wherever the trader happens to
 * be when this module loads — it only tells TradingView where it's embedded.
 */
const FRAME = 'https://www.tradingview-widget.com/embed-widget';

export const tradingView = (widget, config) => {
  const { host, hostname } = window.location;
  const settings = {
    width: '100%',
    height: '100%',
    ...config,
    utm_source: hostname,
    utm_medium: 'widget',
    utm_campaign: widget,
    'page-uri': `${host}/trademate`,
  };
  return `${FRAME}/${widget}/?locale=en#${encodeURIComponent(JSON.stringify(settings))}`;
};
